import { useTokenRenewalContext } from "core/auth/version1/TokenRenewalContext/TokenRenewalContext";
import { App as AppView } from "./Views/App/App";
import { useEffect } from "react";
import { AuthVersionState } from "core/state/authVersionState";

const AppViewWithListeners = () => {
  const { renewToken } = useTokenRenewalContext();

  useEffect(() => {
    if (!window.flutter_inappwebview) {
      document.addEventListener("visibilitychange", renewToken);
    }

    return () => {
      if (!window.flutter_inappwebview) {
        document.removeEventListener("visibilitychange", renewToken);
      }
    };
  });

  return <AppView />;
};

export const App = () => {
  const authVersion = AuthVersionState.get();

  switch (authVersion) {
    case "latest":
      return <AppView />;
    case "old":
    default:
      return <AppViewWithListeners />;
  }
};
